import { NavLink, Outlet, useLocation } from "react-router-dom";
import { Col, Container, ListGroup, Row } from "react-bootstrap";
import { ArrowUpCircle } from "react-bootstrap-icons";
import { PageTitle } from "./Controls/PageTitle";

export interface UserPage {
    text: string;
    url:  string;
}

export interface UserMenuItemProps extends UserPage {
    end?:    boolean;
    active?: boolean;
}

export function UserMenuItem( { text, url, active = false, end = false }: UserMenuItemProps ) {
    const loc = useLocation();
    const className = `${active ? "my-active" : "" }`;
    return <ListGroup.Item key={url}
                           as={NavLink}
                           to={url}     //props on NavLink
                           end={end}    //props on NavLink
                           className={className}>
        {text}
    </ListGroup.Item>;
}

export function AppUser() {
  const loc = useLocation();
  const activeOverride = loc.pathname === "/user";

  return (
    <Container fluid className="pt-2 fullheight">
      <Row className="fullheight">
        <Col
          md={4}
          className="d-none d-md-block fullheight border-end border-1"
        >
          <PageTitle>Account</PageTitle>
          <ListGroup>
            <UserMenuItem text="Overview" url="/user" end active={activeOverride} />
          </ListGroup>
        </Col>

        <Col
          md={8}
          className="fullheight scroll-y-auto p-0 m-0"
        >
          <div className="mx-2">
            <Outlet />
          </div>
        </Col>
      </Row>
    </Container>
  );
}